import { c as _c } from "react/compiler-runtime";
import { SearchFieldPropertiesType } from "@website/ui/search-field/search-field.types";
import { useRef } from "react";
export const useSearchField = properties => {
  const $ = _c(27);
  const {
    autoFocus,
    "aria-label": ariaLabel,
    disabled,
    onChange,
    placeholder,
    value,
    onFocus,
    onBlur,
    onSubmit,
    onStartIconClick,
    onEndIconClick,
    onKeyDown,
    defaultValue,
    ref
  } = properties;
  const temporaryReference = useRef(null);
  const inputReference = ref || temporaryReference;
  let t0;
  if ($[0] !== inputReference) {
    const onRootClick = () => {
      inputReference.current?.focus();
    };
    t0 = {
      onClick: onRootClick
    };
    $[0] = inputReference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== ariaLabel || $[3] !== autoFocus || $[4] !== defaultValue || $[5] !== disabled || $[6] !== inputReference || $[7] !== onBlur || $[8] !== onChange || $[9] !== onFocus || $[10] !== onKeyDown || $[11] !== placeholder || $[12] !== value) {
    t1 = {
      autoFocus,
      "aria-label": ariaLabel,
      ref: inputReference,
      disabled,
      onChange,
      placeholder,
      value,
      onFocus,
      onBlur,
      onKeyDown,
      defaultValue
    };
    $[2] = ariaLabel;
    $[3] = autoFocus;
    $[4] = defaultValue;
    $[5] = disabled;
    $[6] = inputReference;
    $[7] = onBlur;
    $[8] = onChange;
    $[9] = onFocus;
    $[10] = onKeyDown;
    $[11] = placeholder;
    $[12] = value;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== disabled || $[15] !== onSubmit) {
    t2 = {
      tabIndex: -1,
      onClick: onSubmit,
      disabled
    };
    $[14] = disabled;
    $[15] = onSubmit;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== onStartIconClick) {
    t3 = {
      onClick: onStartIconClick
    };
    $[17] = onStartIconClick;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== onEndIconClick) {
    t4 = {
      onClick: onEndIconClick
    };
    $[19] = onEndIconClick;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== t0 || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4) {
    t5 = {
      rootProps: t0,
      inputProps: t1,
      submitButtonProps: t2,
      startIconProperties: t3,
      endIconProperties: t4
    };
    $[21] = t0;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};